import Vue from 'vue'
import Vuex from 'vuex'
import 'es6-promise/auto'
import AppHeader from "@/components/header/AppHeader"
import MobileNav from "@/components/header/MobileNav";
import GoogleMap from "@/components/map/GoogleMap"
import store from "@/store"
import CookieConsent from "@/components/cookie-consent/CookieConsent";
import MainSearch from "@/components/search-form/MainSearch";
import HomeHero from "@/components/hero/HomeHero"

new Vue({
    el: '#app',
    components: {
        AppHeader,
        MobileNav,
        GoogleMap,
        CookieConsent,
        MainSearch,
        HomeHero
    },
    store
})